import { render, staticRenderFns } from "./AccionesVerDocumento.vue?vue&type=template&id=773f4b3c&scoped=true"
import script from "./AccionesVerDocumento.vue?vue&type=script&lang=js"
export * from "./AccionesVerDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773f4b3c",
  null
  
)

export default component.exports